interface StatusBarProps {
  /** Epoch ms of the newest GPS fix in the fleet — the age of the *data*,
   *  not of the last socket frame. */
  lastUpdatedAt: number | null;
  connected: boolean;
  /** True until the first fleet snapshot has arrived: there is no "last fix"
   *  to report yet, and "no data" in red would claim there is none. */
  connecting?: boolean;
  buildId?: string;
  apiVersion?: string;
}

function ago(ms: number): string {
  const s = Math.floor(ms / 1000);
  if (s < 60) return `${s}s ago`;
  const m = Math.floor(s / 60);
  if (m < 60) return `${m}m ago`;
  return `${Math.floor(m / 60)}h ago`;
}

export default function StatusBar({ lastUpdatedAt, connected, connecting = false, buildId, apiVersion = "v1" }: StatusBarProps) {
  // Clamped at zero: device clocks run a second or two ahead of the browser,
  // and an unclamped subtraction rendered "-3s ago".
  const ageMs = lastUpdatedAt ? Math.max(0, Date.now() - lastUpdatedAt) : null;
  const since = connecting ? "connecting…" : ageMs == null ? "no data" : ago(ageMs);
  const stale = !connecting && (ageMs == null || ageMs > 5 * 60 * 1000);
  return (
    <footer className="occ-statusbar mono">
      <span className="sb-item">
        <span className={"dot " + (connected ? "sev-ok" : "sev-crit")} />
        <span>API</span>
        <span className="v">{connected ? "connected" : "reconnecting…"}</span>
      </span>
      <span className="sb-item">
        Last fix <span className={"v " + (stale ? "sev-crit" : "")}>{since}</span>
      </span>
      <span className="grow" />
      {buildId ? <span className="sb-item">Build <span className="v">{buildId}</span></span> : null}
      <span className="sb-item">API <span className="v">{apiVersion}</span></span>
    </footer>
  );
}
